import React from 'react';

import { Header, Spacer, Text } from '@kueski-dev/kueski-design-system';

import { CardContainer } from '../EmailVerification.styles';
import EnvelopAlert from './envelop-alert.svg';

export const ErrorVerificationUI = () => (
  <CardContainer>
    <EnvelopAlert />
    <Spacer $size="spacing06" />
    <Header $align="center" $format="Title/Large/Bold">
      Este enlace ya no funciona
    </Header>
    <Spacer $size="spacing05" />
    <Text $align="center" $color="textSecondary" $format="Body/Large/Regular">
      Este enlace caducó o ya fue usado. Por favor, cierra esta ventana y vuelve a hacer el proceso
      de verificación.
    </Text>
  </CardContainer>
);
